module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAbCAYAAABiFp9rAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOwwAADsMBx2+oZAAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAAWdEVYdENyZWF0aW9uIFRpbWUAMDYvMjkvMjBI86wyAAAA6UlEQVRIieWWXQ2DMBRGD8sETAoONgl1sEmYFCRMAhKQUAmTMAffHiihYbRQVvrCSW5IaHJP7k+aIgkXRpJVPqzLiSQGSZNRMKUZRMb72UqqNVa5NWqXa8CgsV1tBsE0BpnFs+aoZK4ySVIlSfRU7IMATjsl/+EcObsAD/ed0rlYjzejaX+XVn7tnCRJsYo6oA6c2aRqgGMtQw2YxHwtgbbGRE/gnihii6gB3omSNnRwrGUw9HNKoSHQvpjoBlwTRV1IFJtR7K6b4wO83NdHS6JclF0GXxS6QP9hzKmCb4Zir6Bi77oiL9UvrVmwDCIm+18AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/detail.png
// module id = G8/A
// module chunks = 1